module.exports = __webpack_public_path__ + "betting_round-65f6c7488931ceae62caf08bd47d020a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/fi/betting_round.png
// module id = 1171
// module chunks = 1 2